'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /* eslint-disable max-len */
/* eslint-disable no-useless-escape */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VisualWebsiteOptimizer = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(VisualWebsiteOptimizer, _React$Component);

  function VisualWebsiteOptimizer() {
    (0, _classCallCheck3.default)(this, VisualWebsiteOptimizer);
    return (0, _possibleConstructorReturn3.default)(this, (VisualWebsiteOptimizer.__proto__ || (0, _getPrototypeOf2.default)(VisualWebsiteOptimizer)).apply(this, arguments));
  }

  (0, _createClass3.default)(VisualWebsiteOptimizer, [{
    key: 'render',
    value: function render() {
      if (!this.props.options || !this.props.options.enabled) {
        return null;
      }

      return _react2.default.createElement(_reactHelmet2.default, {
        link: [{
          rel: 'preconnect',
          href: 'https://dev.visualwebsiteoptimizer.com'
        }],
        script: [{
          type: 'text/javascript',
          innerHTML: '\n              function isConsentGiven() {\n                var activeGroups = window.OptanonActiveGroups;\n\n                // Check for the \'OptanonAlertBoxClosed\' cookie\n                var optanonClosed = document.cookie.split(\'; \').find(row => row.startsWith(\'OptanonAlertBoxClosed\'));\n\n                if (!optanonClosed) {\n                  return 3;\n                } else {\n                  return activeGroups && activeGroups.split(\',\').indexOf(\'C0002\') > -1 ? 1 : 2;\n                }\n              }\n              window.VWO = window.VWO || [];\n              window.VWO.init = window.VWO.init || function(state) { window.VWO.consentState = state; }\n              window.VWO.init(isConsentGiven());\n            '
        }, {
          type: 'text/javascript',
          innerHTML: '\n              window._vwo_code=window._vwo_code || (function() {\n              var account_id=' + this.props.options.accountId + ',\n              version = 1.5,\n              settings_tolerance=2000,\n              library_tolerance=2500,\n              use_existing_jquery=false,\n              is_spa=1,\n              hide_element=\'body\',\n              hide_element_style = \'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important\',\n              /* DO NOT EDIT BELOW THIS LINE */\n              f=false,w=window,d=document,vwoCodeEl=d.querySelector(\'#vwoCode\'),code={use_existing_jquery:function(){return use_existing_jquery},library_tolerance:function(){return library_tolerance},hide_element_style:function(){return\'{\'+hide_element_style+\'}\'},finish:function(){if(!f){f=true;var e=d.getElementById(\'_vis_opt_path_hides\');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=d.createElement(\'script\');t.fetchPriority=\'high\';t.src=e;t.type=\'text/javascript\';t.onerror=function(){_vwo_code.finish()};d.getElementsByTagName(\'head\')[0].appendChild(t)},getVersion:function(){return version},getMatchedCookies:function(e){var t=[];if(document.cookie){t=document.cookie.match(e)||[]}return t},getCombinationCookie:function(){var e=code.getMatchedCookies(/(?:^|;)s?(_vis_opt_exp_d+_combi=[^;$]*)/gi);e=e.map(function(e){try{var t=decodeURIComponent(e);if(!/_vis_opt_exp_d+_combi=(?:d+,?)+s*$/.test(t)){return\'\'}return t}catch(e){return\'\'}});var i=[];e.forEach(function(e){var t=e.match(/([d,]+)/g);t&&i.push(t.join(\'-\'))});return i.join(\'|\')},init:function(){if(d.URL.indexOf(\'__vwo_disable__\')>-1)return;w.settings_timer=setTimeout(function(){_vwo_code.finish()},settings_tolerance);var e=d.currentScript,t=d.createElement(\'style\'),i=e&&!e.async?hide_element?hide_element+\'{\'+hide_element_style+\'}\':\'\':code.lA=1,n=d.getElementsByTagName(\'head\')[0];t.setAttribute(\'id\',\'_vis_opt_path_hides\');vwoCodeEl&&t.setAttribute(\'nonce\',vwoCodeEl.nonce);t.setAttribute(\'type\',\'text/css\');if(t.styleSheet)t.styleSheet.cssText=i;else t.appendChild(d.createTextNode(i));n.appendChild(t);var o=this.getCombinationCookie();this.load(\'https://dev.visualwebsiteoptimizer.com/j.php?a=\'+account_id+\'&u=\'+encodeURIComponent(d.URL)+\'&f=\'+ +is_spa+\'&vn=\'+version+(o?\'&c=\'+o:\'\'));return settings_timer}};w._vwo_settings_timer = code.init();return code;}());\n            '
        }]
      });
    }
  }]);
  return VisualWebsiteOptimizer;
}(_react2.default.Component), _class.propTypes = {
  options: _react.PropTypes.shape({
    enabled: _react.PropTypes.bool,
    accountId: _react.PropTypes.string
  })
}, _class.defaultProps = {}, _temp);
exports.default = VisualWebsiteOptimizer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/VisualWebsiteOptimizer/index.js
// module id = 604
// module chunks = 0